import { queryClient } from './queryClient';

export const CACHE_ACTIONS = {
    INSERT: 'insert',
    REMOVE: 'remove',
    UPDATE: 'update'
};

export const updateCacheArray = ({ queryKey, action, primaryKey = 'uuid', data, dataTransform }) => {
    ({
        [CACHE_ACTIONS.INSERT]: (newItem) => {
            queryClient.setQueryData(queryKey, (oldData) => {
                if (typeof dataTransform === 'function') {
                    return dataTransform(oldData, newItem);
                }
                return !oldData ? [newItem] : [...oldData, newItem];
            });
        },
        [CACHE_ACTIONS.UPDATE]: (targetItem) => {
            queryClient.setQueryData(queryKey, (oldData) => {
                if (typeof dataTransform === 'function') {
                    return dataTransform({ oldData, targetItem });
                }
                if (oldData) {
                    const oldDataCopy = [...oldData];
                    const targetIndex = oldData.findIndex((item) => item[primaryKey] === targetItem[primaryKey]);

                    if (targetIndex > -1) {
                        oldDataCopy[targetIndex] = targetItem;
                    }

                    return oldDataCopy;
                } else {
                    return oldData;
                }
            });
        },
        [CACHE_ACTIONS.REMOVE]: (targetItem) => {
            queryClient.setQueryData(queryKey, (oldData) => {
                if (typeof dataTransform === 'function') {
                    return dataTransform({ oldData, targetItem });
                }
                if (oldData) {
                    const oldDataCopy = [...oldData];
                    const targetIndex = oldData.findIndex((item) => item[primaryKey] === targetItem);

                    if (targetIndex > -1) {
                        oldDataCopy.splice(targetIndex, 1);
                    }

                    return oldDataCopy;
                } else {
                    return oldData;
                }
            });
        }
    }?.[action]?.(data));
};
